import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/admin/adminLogin.css';
import { loginAdmin } from '../../services/admin/adminAuthService';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false); // 👈 visibilité mot de passe
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const { token } = await loginAdmin(email, password);
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.role === 'admin') {
        localStorage.setItem('token', token);
        navigate('/admin');
      } else {
        alert("Accès refusé");
        console.error('Tentative avec un rôle non autorisé :', payload.role);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        alert('Erreur : ' + err.response.data.error);
        console.error('Erreur backend :', err.response.data.error);
      } else {
        alert('Erreur inconnue. Veuillez réessayer.');
        console.error('Erreur inconnue :', err);
      }
    }
  };

  return (
    <div className="admin-login-container">
      <form onSubmit={handleLogin} className="admin-login-form">
        <h2 className="admin-login-title">Connexion Admin</h2>

        <input
          type="email"
          placeholder="Adresse email"
          onChange={e => setEmail(e.target.value)}
          required
        />

        <div style={{ position: 'relative' }}>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Mot de passe"
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#2e8b57',
              fontSize: '0.9rem'
            }}
          >
            {showPassword ? '👁️ Masquer' : '👁️ Afficher'}
          </button>
        </div>

        <button type="submit">Se connecter</button>
      </form>
    </div>
  );
};

export default AdminLogin;
